module.exports = __webpack_public_path__ + "static/media/Golden tower 10.2cd737bf.webp";